module.exports = __webpack_public_path__ + "img/artboard14.1e4b982a.png";